import axios from 'axios'
import Qs from 'qs'
// 引入Nprogress和CSS
import Nprogress from 'nprogress'
import 'nprogress/nprogress.css'

import Cookies from 'js-cookie'

import {
  MessageBox
} from 'element-ui'
import {
  base
} from './base.js'
const instance = axios.create({
  // 请求根路径
  baseURL: base,
  // 过期时间
  timeout: 60000
})

// 配置请求头
instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
// axios请求拦截器,在请求头中挂载accessToken字段提供token令牌
instance.interceptors.request.use(config => {
  if (config.method === 'get') {
    config.headers.responseContent = 'blob'
  }
  Nprogress.start()
  // 设置accessToken字段值为token
  // config.headers.accessToken = window.sessionStorage.getItem('token')
  config.headers.accessToken = Cookies.get('token')
  // 必须return config
  return config
})
// axios响应拦截器
instance.interceptors.response.use(config => {
  Nprogress.done()
  if (config.data.code === 401) {
    MessageBox.alert('登录信息超时，请重新登录', '登录超时', {
      confirmButtonText: '跳转登录页面',
      callback: action => {
        location.reload()
        // 销毁token
        // window.sessionStorage.clear();
        Cookies.remove('token')
      }
    })
  }
  return config
})
// 请求封装函数
export const createAPI = (url, method, data) => {
  let config = {}
  if (method === 'get') {
    config.params = data
    config.responseType = 'blob'
  } else {
    config.data = Qs.stringify(data)
  }
  return instance({
    url,
    method,
    ...config
  })
}
